import { NO_REACTION } from './megamix';

// SIMPLE COLORS
// {id: 2, name: 'black2', simple: true, hex: '#333333', simpleColorId: 2}
// {id: 5, name: 'blue2', simple: true, hex: '#2b37f6', simpleColorId: 5}
// {id: 8, name: 'green2', simple: true, hex: '#67f02c', simpleColorId: 8}
// {id: 11, name: 'yellow2', simple: true, hex: '#ffff33', simpleColorId: 11}
// {id: 14, name: 'orange2', simple: true, hex: '#fd7322', simpleColorId: 14}
// {id: 17, name: 'brown2', simple: true, hex: '#510b0c', simpleColorId: 17}
// {id: 20, name: 'red2', simple: true, hex: '#ff0000', simpleColorId: 20}
// {id: 23, name: 'pink2', simple: true, hex: '#ff6fcf', simpleColorId: 23}
// {id: 26, name: 'purple2', simple: true, hex: '#50268d', simpleColorId: 26}
const simpleColorCodes = {
  2: 'b', // black2
  5: 'l', // blue2
  8: 'g', // green2
  11: 'y', // yellow2
  14: 'o', // orange2
  17: 'w', // brown2
  20: 'r', // red2
  23: 'p', // pink2
  26: 'u', // purple2
  NO_REACTION: 'n', // purple2
}
const simpleColorCodesInverted = Object.fromEntries(Object.entries(simpleColorCodes).map(a => a.reverse()));

const codesSeparator = "-";

const decodeColorId = (encodedColorId) => {
  let decoded = simpleColorCodesInverted[encodedColorId];
  if (decoded !== NO_REACTION)
    decoded = parseInt(decoded);
  return decoded;
}

const encodeColors = (colorIds) => {
    let encoded = "";
    colorIds.forEach((colorId) => {
      let encodedColor = simpleColorCodes[colorId];
      if (encodedColor == null) {
        console.log("ENCODING ERROR: unable to encode colorId: ", colorId);
      } else {
        encoded += encodedColor;
      }
    })
    return encoded;
};

const encodeReagentId = (reagentId) => {
  return "" + reagentId;
}

export const encodeQueries = (queries) => {
  let encodedQueries = [];

  queries.forEach(query => {

    // Handle 'NO_REACTION' which is not an array
    let colorIds = query.colorIds;
    if (typeof colorIds == "string")
      colorIds = [colorIds];

    if (query.colorIds.length > 0) {
      let encodedColors = encodeColors(colorIds);
      let encodedReagentId = encodeReagentId(query.reagentId);
      let encodedQuery = "" + encodedReagentId + encodedColors;
      encodedQueries.push(encodedQuery);
    }
  });

  return encodedQueries.join(codesSeparator);
}

const decodeQuery = (encodedQuery) => {

  let encodedReagentId = encodedQuery.match(/\d+/);
  if (encodedReagentId) {
    encodedReagentId = encodedReagentId[0];
  } else {
    console.log("ERROR bad query unable to get encoded reagentId: " + encodedQuery);
    return {};
  }

  let encodedColorIds = encodedQuery.match(/[a-z]+/);
  if (encodedColorIds) {
    encodedColorIds = encodedColorIds[0];
  } else {
    console.log("ERROR bad query unable to get encoded colorIds: " + encodedQuery);
    return {};
  }

  const reagentId = parseInt(encodedReagentId)
  if (isNaN(reagentId)) {
    console.log("ERROR bad query unable to decode reagentId: " + encodedQuery);
    return {};
  }

  let colorIds = encodedColorIds.split("").map(encodedColorId => decodeColorId(encodedColorId));
  // Handle 'NO_REACTION' which should not be in array
  if (colorIds[0] == NO_REACTION)
    colorIds = colorIds[0];

  return {reagentId: reagentId, colorIds: colorIds};
};

export const decodeQueries = (encodedQueries) => {
  let queries = [];

  encodedQueries.split(codesSeparator).forEach(encodedQuery => {;
    if (encodedQuery.length > 0) {
        const query = decodeQuery(encodedQuery);
        if (Number.isInteger(query.reagentId)) {
          queries.push(query);
        }
    }
  });

  return queries;
};